class CollectionDescriptionExpandable extends HTMLElement {
  connectedCallback() {
    this.content = this.querySelector('[data-collection-description-content]');
    this.toggle = this.querySelector('[data-collection-description-toggle]');
    this.showMoreLabel = this.querySelector('[data-show-more-label]');
    this.showLessLabel = this.querySelector('[data-show-less-label]');

    if (!this.content || !this.toggle) return;

    this.toggle.addEventListener('click', () => this.toggleExpanded());
    window.addEventListener('resize', () => this.updateToggleVisibility());

    requestAnimationFrame(() => this.updateToggleVisibility());
  }

  isCollapsed() {
    return this.content.classList.contains('is-collapsed');
  }

  toggleExpanded() {
    const collapsed = this.isCollapsed();

    this.content.classList.toggle('is-collapsed', !collapsed);
    this.toggle.setAttribute('aria-expanded', collapsed ? 'true' : 'false');
    this.showMoreLabel.hidden = collapsed;
    this.showLessLabel.hidden = !collapsed;
  }

  updateToggleVisibility() {
    if (!this.isCollapsed()) {
      this.toggle.hidden = false;
      return;
    }

    const needsToggle = this.content.scrollHeight > this.content.clientHeight + 1;
    this.toggle.hidden = !needsToggle;
  }
}

if (!customElements.get('collection-description-expandable')) {
  customElements.define('collection-description-expandable', CollectionDescriptionExpandable);
}
